export const enhanceRecommendedAccessoriesLDFlag = window?.flags?.['GNA-14878-Enhance-Recommended-Accessories'];

export const getAnalyticsModalData = (isAccessoryModal) => {
  const modalData = { modalType: enhanceRecommendedAccessoriesLDFlag ? 'Control B' : 'Control A' }
  const carouselDirectionFromStorage = window.sessionStorage.getItem("carouselDirection");
  const carouselCountFromStorage = window.sessionStorage.getItem("carouselCount");
  if(enhanceRecommendedAccessoriesLDFlag && isAccessoryModal){
    modalData.carouselMovement = carouselDirectionFromStorage
    modalData.showing = carouselCountFromStorage
  }
  return modalData
}
